import { CategoryWithArtistsType as ApiCategoryWithArtistsType } from 'src/api/generated/touring/types';
import { CategoryWithArtistsType } from '../../types';
import { mapArtists } from './helpers';

export const mapCategoriesWithArtists = (
  apiType: ApiCategoryWithArtistsType[]
): CategoryWithArtistsType[] => {
  return apiType.map((category) => ({
    category: category.category,
    artists: mapArtists(category.artists),
  }));
};
